.container {
    composes: container from './graphql-select.module.css';
}

.permission-notice {
    font-size: 11px;
    font-style: italic;
}
